import VideoEmbed from "./VideoEmbed";

export type { Type } from "./VideoEmbed";

export default VideoEmbed;
